import React, { Component } from 'react';

import { Slide } from 'react-slideshow-image';

import Img1 from '../assets/slide-talee/img1.JPG';
import Img2 from '../assets/slide-talee/img2.JPG';
import Img3 from '../assets/slide-talee/img3.JPG';
import Img4 from '../assets/slide-talee/img4.JPG';

import Talea from '../assets/Talea.png';

import '../App.css';


const slideTalee = [
  Img1,
  Img2,
  Img3,
  Img4
];

const propertiesTalee = {
  duration: 4000,
  transitionDuration: 400,
  infinite: true,
  indicators: true,
  arrows: false,
}

class Talee extends Component {
  render() {
    return (
      <div className="App">
      <div className ="prod-title">
        <h1>Talee</h1>
        <br />
      </div>

      <div className ="prod-talee">
        <h2>Dichiarazione di esclusione di responsabilità</h2>
          <h4>CANNABIS L. SATIVA DA SEME <br /><br />
          La suddetta pianta è venduta ai soli fini ornamentali nel rispetto della legge sulla canapa del 2 Dicembre 2016 n° 242 circolare del Ministero della Saluta, 22 Maggio 2009 e Reg. CE n° 112.
          </h4>
        <h2>AVVERTENZE</h2>
          <h4>È d'obbligo esporla a 18 ore di luce all'uopo di impedirne la fioritura. <br />
          Botanica Urbana Senago si solleva da ogni responsabilità in caso di comportamenti inappropriati e che possano andare contro la legislazione vigente in materia di stupefacenti.
          </h4>
      </div>


      <Slide {...propertiesTalee}>
      <div className="talee-slide">
        <img src={slideTalee[0]} alt="Talee" title="Talee" />
      </div>
      <div className="talee-slide">
        <img src={slideTalee[1]} alt="Talee" title="Talee" />
      </div>
      <div className="talee-slide">
        <img src={slideTalee[2]} alt="Talee" title="Talee" />
      </div>
      <div className="talee-slide">
        <img src={slideTalee[3]} alt="Talee" title="Talee" />
      </div>

      </Slide>

      <div className="talee-table">
        <h2>Varietà e dettagli</h2>
          <div className="row-table">
              <div className="item-table">
                  <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                  <h3>Chocolate Mint OG</h3>
                  <div className="detail-talee">
                      <div className="item-detail"><h4>INDICA</h4><h5>80%</h5></div>
                      <div className="item-detail"><h4>SATIVA</h4><h5>20%</h5></div>
                      <div className="item-detail"><h4>THC</h4><h5>22%</h5></div>
                      <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>60</h5></div>
                      <div className="item-detail"><h4>PREZZO</h4><h5>10€</h5></div>
                  </div>
              </div>

              <div className="item-table">
                  <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                  <h3>Blue Gelato 41</h3>
                  <div className="detail-talee">
                      <div className="item-detail"><h4>INDICA</h4><h5>60%</h5></div>
                      <div className="item-detail"><h4>SATIVA</h4><h5>40%</h5></div>
                      <div className="item-detail"><h4>THC</h4><h5>20%</h5></div>
                      <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>70</h5></div>
                      <div className="item-detail"><h4>PREZZO</h4><h5>10€</h5></div>
                  </div>

              </div>


              <div className="item-table">
                  <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                  <h3>American Beauty</h3>
                  <div className="detail-talee">
                      <div className="item-detail"><h4>INDICA</h4><h5>50%</h5></div>
                      <div className="item-detail"><h4>SATIVA</h4><h5>50%</h5></div>
                      <div className="item-detail"><h4>THC</h4><h5>18%</h5></div>
                      <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>65</h5></div>
                      <div className="item-detail"><h4>PREZZO</h4><h5>10€</h5></div>
                  </div>

              </div>
          </div>


          <div className="row-table">
              <div className="item-table">
                  <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                  <h3>Sorbet #4</h3>
                  <div className="detail-talee">
                      <div className="item-detail"><h4>INDICA</h4><h5>60%</h5></div>
                      <div className="item-detail"><h4>SATIVA</h4><h5>40%</h5></div>
                      <div className="item-detail"><h4>THC</h4><h5>20%</h5></div>
                      <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>63</h5></div>
                      <div className="item-detail"><h4>PREZZO</h4><h5>15€</h5></div>
                  </div>

              </div>

              <div className="item-table">
                  <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                  <h3>Gelato Sorbet</h3>
                  <div className="detail-talee">
                      <div className="item-detail"><h4>INDICA</h4><h5>70%</h5></div>
                      <div className="item-detail"><h4>SATIVA</h4><h5>30%</h5></div>
                      <div className="item-detail"><h4>THC</h4><h5>22%</h5></div>
                      <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>58</h5></div>
                      <div className="item-detail"><h4>PREZZO</h4><h5>15€</h5></div>
                  </div>

              </div>


              <div className="item-table">
                  <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                  <h3>Strawberry Sorbet</h3>
                  <div className="detail-talee">
                      <div className="item-detail"><h4>INDICA</h4><h5>60%</h5></div>
                      <div className="item-detail"><h4>SATIVA</h4><h5>40%</h5></div>
                      <div className="item-detail"><h4>THC</h4><h5>21%</h5></div>
                      <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>63</h5></div>
                      <div className="item-detail"><h4>PREZZO</h4><h5>15€</h5></div>
                  </div>

              </div>
          </div>



          <div className="row-table">
              <div className="item-table">
                  <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                  <h3>Kong 47</h3>
                  <div className="detail-talee">
                      <div className="item-detail"><h4>INDICA</h4><h5>50%</h5></div>
                      <div className="item-detail"><h4>SATIVA</h4><h5>50%</h5></div>
                      <div className="item-detail"><h4>THC</h4><h5>18%</h5></div>
                      <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>50</h5></div>
                      <div className="item-detail"><h4>PREZZO</h4><h5>10€</h5></div>
                  </div>

              </div>

              <div className="item-table">
                  <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                  <h3>King Kong</h3>
                  <div className="detail-talee">
                      <div className="item-detail"><h4>INDICA</h4><h5>50%</h5></div>
                      <div className="item-detail"><h4>SATIVA</h4><h5>50%</h5></div>
                      <div className="item-detail"><h4>THC</h4><h5>18%</h5></div>
                      <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>53</h5></div>
                      <div className="item-detail"><h4>PREZZO</h4><h5>10€</h5></div>
                  </div>

              </div>


              <div className="item-table">
                  <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                  <h3>Grandeddy Purple</h3>
                  <div className="detail-talee">
                      <div className="item-detail"><h4>INDICA</h4><h5>80%</h5></div>
                      <div className="item-detail"><h4>SATIVA</h4><h5>20%</h5></div>
                      <div className="item-detail"><h4>THC</h4><h5>18%</h5></div>
                      <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>60</h5></div>
                      <div className="item-detail"><h4>PREZZO</h4><h5>15€</h5></div>
                  </div>

              </div>
          </div>



          <div className="row-table">
              <div className="item-table">
                  <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                  <h3>White Widow</h3>
                  <div className="detail-talee">
                      <div className="item-detail"><h4>INDICA</h4><h5>60%</h5></div>
                      <div className="item-detail"><h4>SATIVA</h4><h5>40%</h5></div>
                      <div className="item-detail"><h4>THC</h4><h5>18,5%</h5></div>
                      <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>56</h5></div>
                      <div className="item-detail"><h4>PREZZO</h4><h5>10€</h5></div>
                  </div>

              </div>

              <div className="item-table">
                  <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                  <h3>Cristal Candy</h3>
                  <div className="detail-talee">
                      <div className="item-detail"><h4>INDICA</h4><h5>60%</h5></div>
                      <div className="item-detail"><h4>SATIVA</h4><h5>40%</h5></div>
                      <div className="item-detail"><h4>THC</h4><h5>16%</h5></div>
                      <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>63</h5></div>
                      <div className="item-detail"><h4>PREZZO</h4><h5>10€</h5></div>
                  </div>

              </div>


              <div className="item-table">
                  <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                  <h3>Gorilla Glue #4</h3>
                  <div className="detail-talee">
                      <div className="item-detail"><h4>INDICA</h4><h5>50%</h5></div>
                      <div className="item-detail"><h4>SATIVA</h4><h5>50%</h5></div>
                      <div className="item-detail"><h4>THC</h4><h5>25%</h5></div>
                      <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>60</h5></div>
                      <div className="item-detail"><h4>PREZZO</h4><h5>10€</h5></div>
                  </div>

              </div>
          </div>



            <div className="row-table">
                <div className="item-table">
                    <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                    <h3>Original Cheese IBL</h3>
                    <div className="detail-talee">
                        <div className="item-detail"><h4>INDICA</h4><h5>50%</h5></div>
                        <div className="item-detail"><h4>SATIVA</h4><h5>50%</h5></div>
                        <div className="item-detail"><h4>THC</h4><h5>18%</h5></div>
                        <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>56</h5></div>
                        <div className="item-detail"><h4>PREZZO</h4><h5>10€</h5></div>
                    </div>

                </div>

                <div className="item-table">
                    <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                    <h3>The Incredible Bulk</h3>
                    <div className="detail-talee">
                        <div className="item-detail"><h4>INDICA</h4><h5>80%</h5></div>
                        <div className="item-detail"><h4>SATIVA</h4><h5>20%</h5></div>
                        <div className="item-detail"><h4>THC</h4><h5>22%</h5></div>
                        <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>50</h5></div>
                        <div className="item-detail"><h4>PREZZO</h4><h5>10€</h5></div>
                    </div>

                </div>


                <div className="item-table">
                    <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                    <h3>Black Dream</h3>
                    <div className="detail-talee">
                        <div className="item-detail"><h4>INDICA</h4><h5>50%</h5></div>
                        <div className="item-detail"><h4>SATIVA</h4><h5>50%</h5></div>
                        <div className="item-detail"><h4>THC</h4><h5>20%</h5></div>
                        <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>50</h5></div>
                        <div className="item-detail"><h4>PREZZO</h4><h5>10€</h5></div>
                    </div>

                </div>
            </div>



            <div className="row-table">
                <div className="item-table">
                    <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                    <h3>Tangie</h3>
                    <div className="detail-talee">
                        <div className="item-detail"><h4>INDICA</h4><h5>30%</h5></div>
                        <div className="item-detail"><h4>SATIVA</h4><h5>70%</h5></div>
                        <div className="item-detail"><h4>THC</h4><h5>22%</h5></div>
                        <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>70</h5></div>
                        <div className="item-detail"><h4>PREZZO</h4><h5>15€</h5></div>
                    </div>

                </div>

                <div className="item-table">
                    <div className="img-talee"><img src={Talea} alt="Talea" width="100%"/></div>
                    <h3>Franco Lemon CHeese</h3>
                    <div className="detail-talee">
                        <div className="item-detail"><h4>INDICA</h4><h5>40 %</h5></div>
                        <div className="item-detail"><h4>SATIVA</h4><h5>60 %</h5></div>
                        <div className="item-detail"><h4>THC</h4><h5>18%</h5></div>
                        <div className="item-detail"><h4>GIORNI DI FIORITURA</h4><h5>70</h5></div>
                        <div className="item-detail"><h4>PREZZO</h4><h5>10€</h5></div>
                    </div>

                </div>

            </div>


      </div>

      </div>
    )
  }
}


export default Talee;
